import React from "react";
import ReactDOM from "react-dom/client";

/**
 * Listado de componentes disponibles
 * 
 * En esta lista se deben agregar todos los componentes que se quieran renderizar, 
 * si no se agregan aquí, no se podrán renderizar en el frontend,
 * no te preocupes del peso de estos componentes, solo se cargarán cuando se necesiten
 */
const components = {
    Navbar: () => import("./Components/Menu/Navbar"),
    CompanySections: () => import("./Components/CompaniesShowcases/companies-sections"),
    UsePresenceData: () => import("./Components/UsePresenceData"),
    CompaniesShowcases: () => import("./Components/CompaniesShowcases/companies-sections"),
    TimelineSectionComponent: () => import("./Components/Timeline/timeline-section")
};

/**
 * Listado de datos que se pueden proveer a los componentes
 */
const dataComponents = {
    'Navbar': {},
    'CompanySections': {},
    'UsePresenceData': {},
    'CompaniesShowcases': {},
    'TimelineItemSectionComponent': {},
    'TimelineSectionComponent': {}
}

// Función para proveer datos a los componentes
window.dataComponent = dataComponents;

// Función para renderizar cualquier componente dinámicamente
window.renderComponent = async (componentName, containerId) => {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error(`No se encontró el contenedor con ID "${containerId}"`);
        return;
    }

    if (!components[componentName]) {
        console.error(`El componente "${componentName}" no existe`);
        return;
    }

    try {
        const Component = (await components[componentName]()).default;
        ReactDOM.createRoot(container).render(<Component />);
    } catch (error) {
        console.error(`Error al cargar "${componentName}":`, error);
    }
};
